import { speed } from 'jquery';
import slick from '../vendors/slider.min';

class MarsSlideshow {
  constructor() {
    this.dots = $('.slick-dots li');
    this.initSliders();
  }

  initSliders() {
    $(
      '.homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .hubsSlider__slider, .quotesVideo__quotes, .testimonialsSlider__slides, .videoContentSlider__slider, .featuredImage__slider, .fullwidth_slider__slider, .rotatingLogosSection__logosWrapper'
    ).on('init', (event, slick) => {
      $('.slick-dots li.slick-active')
        .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
        <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
          <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
      </svg>`);
    });

    // $(".homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .quotesVideo__quotes").on('beforeChange', (event, slick) => {
    //   this.onBeforeChange();
    // });

    $(
      '.homepage_slider__stories, .hubSlider__nav, .storySlider__nav, .pageHeaderSlider, .lcrsSection__slider, .hubsSlider__slider, .quotesVideo__quotes, .testimonialsSlider__slides, .videoContentSlider__slider, .featuredImage__slider, .fullwidth_slider__slider, .rotatingLogosSection__logosWrapper'
    ).on('afterChange', (event, slick) => {
      this.onAfterChange();
    });

    $('.homepage_slider__stories').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.lcrsSection__slider, .quotesVideo__quotes').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });




    $('.featuredImage__slider').slick({
      dots: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.videoContentSlider__slider').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.pageHeaderSlider').slick({
      dots: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      mobileFirst: true,
      cssEase: 'ease-in-out',
      accessibility: false,
    });

    $('.testimonialsSlider__slides').slick({
      dots: true,
      centerPadding: '20px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: true,
      arrows: false,
      dotsClass: 'slick-dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
    });

    $('.hubSlider__slider, .storySlider__slider').on(
      'init',
      (event, slick) => {}
    );


    $('.hubsSlider__slider').on(
      'beforeChange init',
      function (event, slick, currentSlide, nextSlide) {
        let slideTitle = $(`.hubsSlider__slider-item-`+(nextSlide ? nextSlide : '0')).attr('data-slideTitle');
        let slideURL = $(`.hubsSlider__slider-item-`+(nextSlide ? nextSlide : '0')).attr('data-slideURL');
        let dots  = $('.hubsSlider .slick-dots');
        if (!$(".hubsSlider .dots-wrapper").length) {
          $( dots ).wrap( "<div class='dots-wrapper'></div>" ); 
        }

        if($('.home').length) {
          if (!$(".hubsSlider .dots-wrapper .dots-title").length) {
            const arrow = '<svg class="dots-arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10" role="presentation"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M1 5h42M40 1l4 4-4 4"></path></g></svg>';
            let content = slideURL ? '<a class="dots-url" href="'+slideURL+'"><span class="dots-title">'+(slideTitle ? slideTitle : '')+'</span>'+arrow+'</a>' : '<span class="dots-title">'+(slideTitle ? slideTitle : '')+'</span>';
            $('.dots-wrapper').append(content);
          } else {
            $('.dots-wrapper .dots-url').attr('href', slideURL);
            // $('.dots-wrapper .dots-url').hide(200, function() { 
            //   $('.dots-wrapper .dots-title').html(slideTitle);
            // });

            $( ".dots-wrapper .dots-url" ).animate({
              opacity: 0,
              transform: 'scale(0.8)'
            }, 300, function() {
              $('.dots-wrapper .dots-title').html(slideTitle);
            });
          }
        }
      }
    );
    
    $('.hubsSlider__slider').on(
      'afterChange',
      function () {
        if($('.dots-wrapper .dots-url').length) {
          $( ".dots-wrapper .dots-url" ).animate({
            opacity: 1,
            transform: 'scale(1)'
          }, 600);
        }
      }
    );



    $('.hubsSlider__slider').slick({
      dots: true,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: false,
      arrows: false,
      // fade: true,
      dotsClass: 'slick-dots',
      dotsWrapper: '.hubsSlider__dots',
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      useCSS: true,
      pauseOnDotsHover: true,
      respondTo: 'min',
      centerMode: true,
      cssEase: 'easeInCirc',
      speed: 800,
      accessibility: false,
      mobileFirst: true,
      // appendDots:'.dots-container',
    });



    $('.fullwidth_slider__slider').slick({
      dots: false,
      centerPadding: '0px',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      adaptiveHeight: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      useCSS: true,
      respondTo: 'min',
      centerMode: true,
      cssEase: 'ease-in-out',
      accessibility: false,
      mobileFirst: true,
      appendArrows: '.fullwidth_slider__sliderArrow',
      nextArrow : '<button class="slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.293 0.29304C8.48053 0.105569 8.73484 0.000254249 9 0.000254238C9.26516 0.000254226 9.51947 0.105568 9.707 0.29304L15.707 6.29304C15.8945 6.48057 15.9998 6.73488 15.9998 7.00004C15.9998 7.2652 15.8945 7.51951 15.707 7.70704L9.707 13.707C9.61475 13.8026 9.50441 13.8787 9.3824 13.9311C9.2604 13.9836 9.12918 14.0111 8.9964 14.0123C8.86362 14.0134 8.73194 13.9881 8.60905 13.9379C8.48615 13.8876 8.3745 13.8133 8.28061 13.7194C8.18671 13.6255 8.11246 13.5139 8.06218 13.391C8.0119 13.2681 7.9866 13.1364 7.98775 13.0036C7.9889 12.8709 8.01649 12.7396 8.0689 12.6176C8.12131 12.4956 8.19749 12.3853 8.293 12.293L12.586 8.00004L1 8.00004C0.734783 8.00004 0.480429 7.89468 0.292893 7.70715C0.105357 7.51961 -2.94924e-07 7.26526 -3.06517e-07 7.00004C-3.1811e-07 6.73482 0.105356 6.48047 0.292893 6.29293C0.480429 6.1054 0.734783 6.00004 1 6.00004L12.586 6.00004L8.293 1.70704C8.10553 1.51951 8.00021 1.26521 8.00021 1.00004C8.00021 0.734876 8.10553 0.480568 8.293 0.29304Z" fill="white"/></svg></button>',
      prevArrow : '<button class="slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.707 14.707C7.51947 14.8944 7.26516 14.9997 7 14.9997C6.73484 14.9997 6.48053 14.8944 6.293 14.707L0.292999 8.70696C0.105528 8.51943 0.000213305 8.26512 0.000213317 7.99996C0.000213328 7.73479 0.105528 7.48049 0.292999 7.29296L6.293 1.29296C6.38525 1.19745 6.49559 1.12127 6.6176 1.06886C6.7396 1.01645 6.87082 0.988862 7.0036 0.987708C7.13638 0.986554 7.26806 1.01186 7.39095 1.06214C7.51385 1.11242 7.6255 1.18667 7.71939 1.28056C7.81329 1.37446 7.88754 1.48611 7.93782 1.609C7.9881 1.7319 8.0134 1.86358 8.01225 1.99636C8.0111 2.12914 7.98351 2.26036 7.9311 2.38236C7.87869 2.50437 7.80251 2.61471 7.707 2.70696L3.414 6.99996L15 6.99996C15.2652 6.99996 15.5196 7.10532 15.7071 7.29285C15.8946 7.48039 16 7.73474 16 7.99996C16 8.26518 15.8946 8.51953 15.7071 8.70707C15.5196 8.8946 15.2652 8.99996 15 8.99996L3.414 8.99996L7.707 13.293C7.89447 13.4805 7.99979 13.7348 7.99979 14C7.99979 14.2651 7.89447 14.5194 7.707 14.707Z" fill="white"/></svg></button>',
    });


    $('.rotatingLogosSection__logosWrapper').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      centerPadding: '20px',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
      ],
      variableWidth: false,
      adaptiveHeight: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: false,
      fade: false,
      useCSS: true,
      // centerMode: true,
      cssEase: 'ease-in-out',
      // asNavFor: '.hubSlider__nav',
      accessibility: false,
    });

    $('.hubSlider__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: false,
      fade: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      asNavFor: '.hubSlider__nav',
      accessibility: false,
    });
    $('.hubSlider__nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.hubSlider__slider',
      infinite: true,
      arrows: false,
      dots: true,
      useTransform: false,
      dotsClass: 'slick-dots',
      variableWidth: true,
      focusOnSelect: true,
      useCSS: true,
      accessibility: false,
    });

    $('.storySlider__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      adaptiveHeight: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      arrows: false,
      fade: true,
      useCSS: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      asNavFor: '.storySlider__nav',
      accessibility: false,
    });
    $('.storySlider__nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.storySlider__slider',
      infinite: true,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots',
      useTransform: false,
      variableWidth: true,
      focusOnSelect: true,
      useCSS: true,
      accessibility: false,
    });

    // Remove active class from all thumbnail slides
    $(
      '.hubSlider__nav .slick-slide, .storySlider__nav .slick-slide'
    ).removeClass('slick-active');

    // Set active class to first thumbnail slides
    $('.hubSlider__nav .slick-slide, .storySlider__nav .slick-slide')
      .eq(0)
      .addClass('slick-active');
  }

  sliderEvents() {}

  onBeforeChange() {
    $('.circle-chart').remove();
    $('.slick-dots li.slick-active').next()
      .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
  <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2.5" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
  <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2.5" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
</svg>`);
  }

  onAfterChange() {
    $('.circle-chart').remove();
    $('.slick-dots li.slick-active')
      .append(`<svg class="circle-chart" viewbox="0 0 33.83098862 33.83098862" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
  <circle class="circle-chart__background" stroke="#DEDEDE" stroke-width="2.5" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
  <circle class="circle-chart__circle" stroke="#003DA5" stroke-width="2.5" stroke-dasharray="100,100" stroke-linecap="round" fill="none" cx="16.91549431" cy="16.91549431" r="15.91549431" />
</svg>`);
  }
}

export default MarsSlideshow;
